import {
    getRecordingStartTime,
    stopScreenCapture,
} from '../../background/services'
import {
    DISPLAY_COUNTDOWN_TIME,
    MAX_VIDEO_LENGTH,
} from '../../background/constants'
import { COUNTDOWN_ID, getRecControls } from '../parentConfig'

const calcCountDown = (startTime: number) => {
    const recTimeInProgress: number = Math.round(
        (Date.now() - startTime) / 1000
    )

    return MAX_VIDEO_LENGTH - recTimeInProgress
}

const parseCountdown = (countDown: number) =>
    `${Math.floor(countDown / 60)}:${
        countDown % 60 < 10 ? `0${countDown % 60}` : countDown % 60
    }`

let intervalId: number | null = null

export const startCountdown = () => {
    const recPanel = getRecControls()
    const countdownNode = recPanel?.shadowRoot?.getElementById(COUNTDOWN_ID)

    if (!countdownNode) return

    getRecordingStartTime(startTime => {
        let countDownTime: number = calcCountDown(startTime)

        if (startTime && countDownTime > 0) {
            intervalId = window.setInterval(() => {
                if (countDownTime === 0) {
                    stopScreenCapture({
                        mxpMeta: { stopSource: 'parentCountdown' },
                    })
                    countdownNode.parentElement?.remove()
                }

                const updatedCountDown = calcCountDown(startTime) // Recalculate to display more accurate data

                if (updatedCountDown < DISPLAY_COUNTDOWN_TIME) {
                    countdownNode.innerHTML = parseCountdown(updatedCountDown)
                    const countdownContainer = countdownNode.parentElement

                    if (
                        countdownContainer &&
                        countdownContainer.style.display === 'none'
                    ) {
                        countdownContainer.style.display = 'flex'
                    }
                }

                countDownTime = updatedCountDown
            }, 1000)
        }
    })
}

export const deleteCountdown = () => {
    if (intervalId) {
        window.clearInterval(intervalId)
        intervalId = null
    }
}
